module.exports = __webpack_public_path__ + "img/114ne.04bef445.svg";